import { IStore } from "../../store";
import { TORB3Actions } from "./actions";
import { IAuthActions } from "../auth/actions";
import orb3HistoryMiddleware from "./middlewares/history.middleware";
import createMiddleware from "../../_core/create-middleware";

const orb3BaseMiddleware = createMiddleware<
	IStore,
	TORB3Actions | IAuthActions
>().getMiddleware();

const orb3Middlewares = [orb3BaseMiddleware, orb3HistoryMiddleware];

export default orb3Middlewares;
